import React, { useRef, useState } from 'react'
import { motion, useScroll } from 'framer-motion'
import { SiTypescript } from 'react-icons/si';
import { SiMongodb } from 'react-icons/si';
import { SiNextdotjs, SiNestjs, SiPostgresql } from 'react-icons/si';

const containerVariant = {
    hidden: {
        scale: 0,
        opacity:0
    },
    visible: {
        scale: 1,
        opacity:1
    }
}

const Skills = ({setCursorVariant,setMessage}) => {
    
    return (
        <div className="container" >
            <section className='skills m-5'>
                <div className='skill-set'>

                    <motion.h1 whileInView={{ scale: 1, originX: 0.5 }} initial={{ scale: 0 }} >skill set</motion.h1>

                    <motion.p whileInView={{ opacity: 1 }} initial={{ opacity: 0 }}>With skills in some different fields of web development, I am the perfect person to hire when it comes to a full fledged project. Whatever your needs are, I can pretty much take on any challenge.</motion.p>
                </div>
                <div className='skills-container' >
                    <motion.div className='row section ' variants={containerVariant} initial={'hidden'} whileInView={'visible'}>

                        <div className='col-lg-6 col-12 skill'>
                            <span>html</span>
                            <i className="fa-brands fa-html5 text-danger" ></i>
                            <p> Semantic HTML Markup
                                - Responsive Design
                                - Cross Browser Compatibility
                                - Accessibility Standards
                                - SEO Optimization</p>
                        </div>
                        <div className='col-lg-6 col-12 skill'>
                            <span>css</span>
                            <i className="fa-brands fa-css3 text-info" ></i>
                            <p> CSS3 Animations & Transitions
                                - Flexbox & Grid Layout
                                - Responsive Design
                                - Cross Browser Compatibility
                                - Preprocessors (Sass)
                                - CSS Frameworks (Bootstrap)
                                - tailwind css
                            </p>
                        </div>
                    </motion.div>
                    <motion.div className='row section ' variants={containerVariant} initial={'hidden'} whileInView={'visible'} >

                        <div className='col-lg-6 col-12 skill'>
                            <span>javascript</span>
                            <i className="fa-brands fa-js text-warning"></i>
                            <p>ES6 Syntax & Features
                                - DOM Manipulation & Traversal
                                - AJAX/JSON Requests & Responses
                                - Asynchronous Programming (Promises, Callbacks)</p>
                        </div>
                        <div className='col-lg-6 col-12 skill'>
                            <span>react js</span>
                            <i className="fa-brands fa-react text-primary" ></i>
                            <p>Component Based Architecture
                                - JSX Syntax
                                - State Management (Redux, Context API)
                                - React Router
                                - React Hooks</p>
                        </div>
                        
                    </motion.div>
                    <motion.div className='row section ' variants={containerVariant} initial={'hidden'} whileInView={'visible'} >

                        <div className='col-lg-6 col-12 skill'>
                            <span>next js</span>
                            <SiNextdotjs />
                            <p>Responsive Design
                                - Grid System
                                - Components and Widgets
                                - Cross Browser Compatibility
                                - Customizable CSS Styles </p>
                        </div>
                        <div className='col-lg-6 col-12 skill'>
                            <span>typescript</span>
                            <SiTypescript color='blue' style={{background:"blue"}} stroke='blue'/>
                            <p>Writing type-safe code-Creating interfaces and types-Using TypeScript with React components-
                                Setting up a TypeScript project from scratch-Using TypeScript with popular front-end libraries and frameworks
                                </p>
                        </div>
                    </motion.div>
                    <motion.div className='row section ' variants={containerVariant} initial={'hidden'} whileInView={'visible'} >

                        <div className='col-lg-6 col-12 skill'>
                            <span>node js</span>
                            <i className="fa-brands fa-node text-success"></i>
                            <p>- Basic understanding of Node.js and its architecture
                                - Familiarity with Node Package Manager (NPM)
                                -Express.js
                                - Experience working with Node.js modules and libraries
                                - Knowledge of asynchronous programming in Node.js
                                - Understanding of RESTful API development using Node.js</p>
                        </div>
                        <div className='col-lg-6 col-12 skill'>
                            <span>MongoDB</span>
                            <SiMongodb color='green' />
                            <p>- Basic understanding of NoSQL databases and MongoDB's document-oriented data model
                                - Experience working with MongoDB queries and aggregation pipelines
                                - Familiarity with MongoDB's indexing and sharding features
                                - Knowledge of MongoDB's replication and high availability features</p>
                        </div>
                    </motion.div>
                    <motion.div className='row section ' variants={containerVariant} initial={'hidden'} whileInView={'visible'} >

                        <div className='col-lg-6 col-12 skill'>
                            <span>nest js</span>
                            <SiNestjs />
                            <p>- Dependency Injection
                                - Decorators
                                -Modules
                                - Controllers
                                - Services
                                - Providers
                                -Nest CLI
                            </p>
                        </div>
                        <div className='col-lg-6 col-12 skill'>
                            <span>postgreSQL</span>
                            <SiPostgresql />
                            <p>- Basic understanding of SQL databases and Prisma ORM.
                                - Experience working with queries
                              </p>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    )
};

export default Skills